export const combineRegexp = (...regexps: Array<RegExp>) => new RegExp(regexps
  .map((regex) => regex.source).join('|'));
export const quitAnswer = new RegExp('([qQ]{1}|[qQ]{1}uit)');
export const noAnswer = new RegExp('([nN]{1}[oO]{1})');
export const isoDate = new RegExp('(\\d{4}-[01]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d:[0-5]\\d\\.\\d+([+-][0-2]\\d:[0-5]\\d|Z))|(\\d{4}-[01]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d:[0-5]\\d([+-][0-2]\\d:[0-5]\\d|Z))|(\\d{4}-[01]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d([+-][0-2]\\d:[0-5]\\d|Z))');
export const dynamicValue = new RegExp('({[a-zA-Z1-9]+})');
export const psychicBioPath = /^\/{0,1}psychics(-new){0,1}\/[a-zA-Z]+-\d{4}$/g;
